export const marketEn = {
  market: {
    title: "Market Intelligence",
    subtitle: "Stay updated with agricultural market trends",
    currentPrices: "Current Prices",
    priceHistory: "Price History",
    forecasts: "Forecasts",
    commodities: "Commodities",
    wheat: "Wheat",
    corn: "Corn",
    soybeans: "Soybeans",
    olives: "Olives",
    grapes: "Grapes",
    pricePerTon: "Price per ton",
    change: "Change",
    trend: "Trend",
    up: "Up",
    down: "Down",
    stable: "Stable"
  },
  marketPage: {
    title: "Market Prices",
    subtitle: "International commodity prices and market analysis for agricultural products",
    overview: "Overview",
    forecasts: "Forecasts",
    calculator: "Calculator",
    priceTrends: "Price Trends",
    priceTrendsDesc: "Historical analysis & forecasting",
    regionalComparison: "Regional Comparison",
    regionalComparisonDesc: "International price benchmarks",
    marketAnalytics: "Market Analytics",
    marketAnalyticsDesc: "Advanced market insights",
    marketHighlights: "Market Highlights",
    globalMarketConditions: "🌍 Global Market Conditions",
    globalMarketDesc: "Mediterranean agricultural markets showing seasonal stability with strong demand from European consumers. Weather conditions favorable for current harvest expectations.",
    tradingOpportunities: "📈 Trading Opportunities",
    tradingOpportunitiesDesc: "Premium quality products commanding higher prices. Consider strategic timing for harvest and sales based on current market premiums.",
    marketIntelligence: "Market Intelligence",
    marketDataSources: "Market Data Sources",
    marketDataSourcesDesc: "Prices sourced from: International Olive Council (IOC) • Organisation Internationale de la Vigne et du Vin (OIV) • Mercasa Spain • Alpha Vantage • Trading Economics • Real-time market feeds"
  },
  forecast: {
    title: "Commodity Price Forecasts",
    subtitle: "AI-powered forecasts from Perplexity Finance with real exchange data",
    commodity: "Commodity",
    timeframe: "Timeframe",
    refreshForecast: "Refresh Forecast",
    loading: "Loading...",
    generatingForecast: "Generating forecast...",
    currentPrice: "Current Price",
    forecastRange: "Forecast Range",
    marketDirection: "Market Direction",
    confidenceLevel: "Confidence Level",
    bullish: "Bullish",
    bearish: "Bearish",
    neutral: "Neutral",
    detailedAnalysis: "Detailed Market Analysis",
    futuresContracts: "Futures Contracts",
    exchange: "Exchange",
    contractMonth: "Contract Month",
    priceUsd: "Price (USD)",
    priceEur: "Price (EUR)",
    change: "Change",
    riskFactors: "Risk Factors",
    supplyDemand: "Supply & Demand",
    supply: "Supply",
    demand: "Demand",
    recommendation: "Recommendation",
    dataSources: "Data Sources",
    sourceType: "Type",
    sourceName: "Source",
    noForecast: "No forecast available. Click 'Refresh Forecast' to generate.",
    forecastUpdated: "Forecast Updated",
    expertViews: "Expert Views",
    analystConsensus: "Analyst Consensus",
    seasonalPattern: "Seasonal Pattern",
    yearOverYear: "Year over Year",
    high: "High",
    medium: "Medium",
    low: "Low",
    buy: "Buy",
    sell: "Sell",
    hold: "Hold",
    probability: "Probability",
    impact: "Impact",
    positive: "Positive",
    negative: "Negative",
    "7days": "7 Days",
    "30days": "30 Days",
    "90days": "90 Days",
    perUnit: "per",
    expectedChange: "Expected change",
    basedOnAnalysis: "Based on market analysis",
    oliveOil: "Extra Virgin Olive Oil",
    wineGrapes: "Wine Grapes (Tempranillo)",
    tableGrapes: "Table Grapes",
    wheatLabel: "Wheat",
    cornLabel: "Corn",
    sunflowerLabel: "Sunflower",
    canolaLabel: "Canola",
    soybean: "Soybean",
    barley: "Barley",
    rice: "Rice",
    "1month": "1 Month",
    "3months": "3 Months",
    "6months": "6 Months",
    "12months": "12 Months"
  },
  priceTrend: {
    title: "Historical Price Analysis",
    chartLine: "Line",
    chartArea: "Area",
    generateHistory: "Generate History",
    generating: "Generating...",
    historicalMin: "Historical Min",
    historicalMax: "Historical Max",
    averagePrice: "Average Price",
    currentPrice: "Current Price",
    volatility: "Volatility",
    dataPoints: "Data Points",
    priceChange: "Price Change",
    dayForecast: "7-Day Forecast",
    priceVolatility: "Price Volatility",
    marketRecommendation: "Market Recommendation",
    officialSources: "Official Data Sources",
    noData: "No price data available",
    "7days": "7 Days",
    "30days": "30 Days",
    "3months": "3 Months",
    "6months": "6 Months",
    "1year": "1 Year",
    "2years": "2 Years"
  },
  regional: {
    title: "Regional Price Comparison",
    region: "Region",
    price: "Price",
    quality: "Quality",
    marketSource: "Market Source",
    competitiveness: "Competitiveness",
    lastUpdated: "Last Updated",
    competitive: "Competitive",
    premium: "Premium",
    marketRate: "Market Rate",
    insights: "Regional Market Insights",
    competitiveDesc: "Price 5%+ below average - Good buying opportunity",
    premiumDesc: "Price 5%+ above average - Premium quality or limited supply",
    marketRateDesc: "Price within ±5% of average - Standard market conditions",
    noData: "No regional price data available"
  },
  analytics: {
    title: "Market Analytics",
    subtitle: "Advanced analysis of trends, volatility and market predictions",
    aiIntelligence: "AI Intelligence",
    updateData: "Update Data",
    currentPrice: "Current Price",
    change: "Change",
    volatility: "Volatility",
    forecast30d: "30d Forecast",
    priceEvolution: "Price Evolution",
    marketAnalysis: "Market Analysis",
    currentTrend: "Current Trend",
    periodData: "Period Data",
    periodDataDesc: "Analysis based on {count} real data points from official agricultural and commodity market sources.",
    forecasts: "Forecasts",
    marketRecommendation: "Market Recommendation",
    keyFactors: "Key Factors",
    realTimeDataSources: "Real-Time Data Sources",
    dataSourcesDesc: "Data from official markets: MATIF • IOC • OIV • MAPA Spain • Poolred • AI analysis via Perplexity sonar-pro",
    aiMarketIntelligence: "AI Market Intelligence",
    marketAssessment: "Market Assessment",
    keyMarketDrivers: "Key Market Drivers",
    aiRecommendation: "AI Recommendation",
    sources: "Sources",
    couldNotLoad: "Could not load market analysis data."
  }
};
